import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon360 } from '@yme/assets/icons';
import { FADED_VARIANT, SIZE_44, TRAILING_ICON } from '@yme/atoms/button';
import { setView360State, getView360State } from '@yme/pdp-components/ProductCard';
import { ButtonStyled } from './styled';
function View360ButtonElement({ labels, isRightToLeft, btnRef }) {
    const dispatch = useDispatch();
    const view360State = useSelector(getView360State);
    const toggle360View = useCallback(() => {
        dispatch(setView360State(!view360State));
    }, [dispatch, view360State]);
    return (React.createElement(ButtonStyled, { buttonRef: btnRef, id: "view360buttonId" // TODO: (D.K.) Need replace this 'id' with dynamic unique-value
        , buttonVariant: FADED_VARIANT, hasIconButton: TRAILING_ICON, size: SIZE_44, onClick: toggle360View, label: view360State ? labels.view360ExitButtonLabel : labels.view360EnterButtonLabel, iconComponent: Icon360, isRightToLeft: isRightToLeft }));
}
export const View360Button = memo(View360ButtonElement);
